module.exports = __webpack_public_path__ + "img/send_gift.ffaf1b6c.png";